/* Ornamint mobile nav v2: the menu drawer (#OrnMnav, sections/orn-mobile-nav.liquid) and the tab bar's Shop button.
   - Mobile header layout only (html.orn-hdr:not(.orn-hdr-desk)): the header menu button and [data-orn-mnav-open] open
     this drawer; the theme's own drawer is not opened (the click is taken in the capture phase before the theme sees it).
   - Flat list, no accordions. Focus trap, Esc closes, page scroll locked (html.orn-mnav-lock), any link tap closes.
   - The wordmark in the drawer head is a copy of the header's own wordmark image (snippets/orn-logo.liquid output, the
     current family / style / custom logo), made on first open.
   - Keeps the Bag tab's accessible name in step with the live count ([data-js-cart-count], updated by the cart drawer). */
(function () {
  var d = document, html = d.documentElement;
  var root, lastTrigger = null, closeT;
  var desk = function () { return html.classList.contains('orn-hdr-desk'); };
  function el() { root = d.getElementById('OrnMnav'); return root; }
  function triggers() { return d.querySelectorAll('[data-orn-mnav-open], .header__row-mobile [data-js-menu-button]'); }
  function isOpen() { return !!(root && root.classList.contains('is-open')); }
  function focusables() {
    return [].slice.call(root.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (x) { return x.offsetParent !== null || x === d.activeElement; });
  }
  function logo() {
    var slot = root.querySelector('[data-orn-mnav-logo]');
    if (!slot || slot.firstChild) return;
    var src = d.querySelector('.header__row-mobile .header__logo img') || d.querySelector('.header__logo img');
    if (!src) { slot.textContent = 'Ornamint'; return; }
    var img = src.cloneNode(true);
    img.removeAttribute('fetchpriority'); img.removeAttribute('id'); img.setAttribute('loading', 'eager'); img.alt = '';
    img.removeAttribute('style'); img.className = 'orn-mnav__logo-img';
    slot.appendChild(img);
  }
  function setExpanded(on) { [].forEach.call(triggers(), function (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  function open(trigger) {
    if (!el() || isOpen() || desk()) return;
    clearTimeout(closeT);
    lastTrigger = trigger || d.activeElement;
    logo();
    root.hidden = false;
    void root.offsetWidth;            // start the fade / slide from the closed state
    root.classList.add('is-open');
    html.classList.add('orn-mnav-lock');
    setExpanded(true);
    var body = root.querySelector('.orn-mnav__body'); if (body) body.scrollTop = 0;
    var c = root.querySelector('[data-orn-mnav-close]'); if (c) c.focus({ preventScroll: true });
  }
  function close(restore) {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    html.classList.remove('orn-mnav-lock');
    setExpanded(false);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var done = function () { if (!isOpen()) root.hidden = true; };
    if (reduce) done(); else closeT = setTimeout(done, 360);
    if (restore !== false && lastTrigger && lastTrigger.isConnected && lastTrigger.offsetParent !== null) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }
  // capture phase on window: before the theme's own menu button handler (which would open its drawer)
  window.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var opener = t.closest('[data-orn-mnav-open]') || t.closest('.header__row-mobile [data-js-menu-button]');
    if (opener && !desk() && el()) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (isOpen()) close(); else open(opener);
      return;
    }
    if (!isOpen() || !root.contains(t)) return;
    if (t.closest('[data-orn-mnav-close]')) { e.preventDefault(); close(); return; }
    var a = t.closest('a[href]');
    // any link closes the drawer (no focus restore: the page is navigating, or it is the same page)
    if (a && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) close(false);
  }, true);
  d.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = d.activeElement;
    if (e.shiftKey && (a === first || !root.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !root.contains(a))) { e.preventDefault(); first.focus(); }
  }, true);
  // the layout switched to desktop (rotation / resize) while open: close without moving focus
  window.addEventListener('resize', function () { if (isOpen() && desk()) close(false); });
  // back / forward cache: never come back to a locked page with the drawer open
  window.addEventListener('pageshow', function (e) { if (e.persisted && el() && isOpen()) { root.classList.remove('is-open'); root.hidden = true; html.classList.remove('orn-mnav-lock'); setExpanded(false); } });
  d.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#OrnMnav')) html.classList.remove('orn-mnav-lock'); });

  // Bag tab: accessible name follows the live count
  function bagLabel() {
    var bag = d.querySelector('[data-orn-tabbar-bag]'), n = bag && bag.querySelector('[data-js-cart-count]');
    if (!n) return;
    var c = parseInt(n.textContent, 10) || 0;
    bag.setAttribute('aria-label', 'Bag, ' + c + (c === 1 ? ' item' : ' items'));
  }
  function watchBag() {
    var n = d.querySelector('[data-orn-tabbar-bag] [data-js-cart-count]');
    if (n && window.MutationObserver) new MutationObserver(bagLabel).observe(n, { childList: true, characterData: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', watchBag); else watchBag();
})();
